// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bannerPic":"bannerPic-2e5oIlqN","current":"current-krxAAwgQ","pic_img":"pic_img-3LUBv770","trans":"trans-1DPy2HeR","text":"text-1LrW6_Eg","title":"title-3Ik1SLE5"};